import initialState from './initialState';
import {SHOW_MODAL, HIDE_MODAL} from '../actions/actionTypes';

export default function modal(state = initialState.modal, action) {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        ...state,
        ...action.modal
      };
    case HIDE_MODAL:
      return {
        ...initialState.modal,
        ...action.modal
      };
    default:
      return state;
  }
}
